import { useMemo } from 'react'
import { TableOfContents } from 'wss3-forge'

interface DocsTableOfContentsProps {
  content: string
}

export function DocsTableOfContents({ content }: DocsTableOfContentsProps) {
  const items = useMemo(() => {
    const headingRegex = /^(#{2,3})\s+(.+)$/gm
    const parsed: Array<{ id: string; title: string; level: number }> = []
    let match

    while ((match = headingRegex.exec(content)) !== null) {
      const level = match[1].length
      const title = match[2].trim()
      const id = title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')

      parsed.push({ id, title, level })
    }

    return parsed
  }, [content])

  if (items.length === 0) return null

  return (
    <aside
      style={{
        position: 'fixed',
        top: 140,
        right: 32,
        width: 280,
        maxHeight: 'calc(100vh - 180px)',
        overflowY: 'auto'
      }}
    >
      <TableOfContents
        items={items}
        title="On this page"
        variant="default"
        autoTrack
        scrollOffset={150}
      />
    </aside>
  )
}
